// import { io } from "socket.io-client";
// import store from "../redux/store";

// export function createSocket() {
//   const state = store.getState();
//   const token = state.auth.authToken;

//   const baseUrl =
//     process.env.REACT_APP_ENVIRONMENT === "PRODUCTION"
//       ? process.env.REACT_APP_API_BASE_URL
//       : process.env.REACT_APP_API_STAGING_BASE_URL;

//   // Create socket with JWT token
//   const socket = io(baseUrl, {
//     withCredentials: false, // since you're not using cookies
//     auth: {
//       token: `Bearer ${token}`, // 👈 send as Bearer token
//     },
//   });

//   // Debug events
//   socket.on("connect", () => {
//     console.log("✅ Socket connected:", socket.id);
//   });

//   socket.on("disconnect", (reason) => {
//     console.log("❌ Socket disconnected:", reason);
//   });

//   socket.on("connect_error", (err) => {
//     console.error("⚠️ Socket connection error:", err.message);
//   });

//   return socket;
// }

import { io } from "socket.io-client";
import store from "../redux/store";

let socket;

export function getSocket() {
  if (!socket) {
    const state = store.getState();
    const token = state.auth.authToken;

    const baseUrl =
      process.env.REACT_APP_ENVIRONMENT === "PRODUCTION"
        ? process.env.REACT_APP_WEBSOCKET_URL
        : process.env.REACT_APP_WEBSOCKET_STAGING_URL;

    socket = io(baseUrl, {
      withCredentials: false,
      auth: {
        token: `Bearer ${token}`,
      },
    });

    // Debug events
    socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
    socket.on("disconnect", (reason) =>
      console.log("❌ Socket disconnected:", reason),
    );
    socket.on("connect_error", (err) =>
      console.error("⚠️ Socket connection error:", err.message),
    );
  }
  return socket;
}

export function getSocket2() {
  if (!socket) {
    const token = process.env.REACT_APP_PERMANENT_SOCKET_KEY;

    const baseUrl =
      process.env.REACT_APP_ENVIRONMENT === "PRODUCTION"
        ? process.env.REACT_APP_WEBSOCKET_URL
        : process.env.REACT_APP_WEBSOCKET_STAGING_URL;

    socket = io(baseUrl, {
      path: "/socket.io",
      withCredentials: false,
      auth: {
        token: `Bearer ${token}`,
      },
    });

    // Debug events
    socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
    socket.on("disconnect", (reason) =>
      console.log("❌ Socket disconnected:", reason),
    );
    socket.on("connect_error", (err) =>
      console.error("⚠️ Socket connection error:", err.message),
    );
  }
  return socket;
}
